import { collectionCards } from '@/mocks/gossipData';
import { SectionHead } from './common';

export default function CollectionStrip() {
  return (
    <section id="collection" className="w-full scroll-mt-24 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHead
            eyebrow="专题合集"
            title="按话题追完整脉络"
            desc="单个事件往往反复翻转，与其零散刷帖，不如从成体系的专题合集入口切入，前因后果一次理清。"
          />
          <button
            type="button"
            className="group inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap self-start rounded-full border border-background-200 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 md:self-auto"
          >
            全部专题合集
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
          </button>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {collectionCards.map((c, idx) => (
            <a
              key={c.title}
              href="#collection"
              className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-background-300"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={c.image}
                  alt={`抖阴黑料 专题合集${c.title}封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex h-6 w-6 items-center justify-center rounded-full bg-background-50/95 text-xs font-black text-primary-600">
                  {String(idx + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {c.title}
                  </h3>
                </div>
                <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">{c.desc}</p>
                <div className="mt-auto flex items-center justify-between pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5"><i className="ri-file-list-3-line text-primary-500" /> {c.count}</span>
                  <span className="inline-flex items-center gap-1 text-primary-600 transition-transform group-hover:translate-x-0.5">
                    进入合集 <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}